$(document).ready(() => {
	ActionTemplatePicker.construct();
});

module ActionTemplatePicker {
	let departmentSelect: JQuery<HTMLElement>;
	let templateSelect: JQuery<HTMLElement>;

	export function construct() {
		departmentSelect = $("#ActionTemplatePickerDepartmentSelect");
		if (departmentSelect.length === 0) {
			return;
		}
		templateSelect = $("#ActionTemplatePickerTemplateSelect");
		departmentSelect.change(onDepartmentSelectChanged);
		onDepartmentSelectChanged();//Throw once to load the default Department's Templates.
	}

	function onDepartmentSelectChanged() {
		templateSelect.empty();
		templateSelect.prop("readonly", true);
    const departmentId = getSelectedDepartment();
    const actionTemplateModes = getSelectedModes();
    const onlyFaxReceivable = getOnlyFaxReceivable();
    ActionTemplateFactory.getActionTemplateByDepartment(departmentId, (actionTemplateStubs) => onActionTemplateListReceived(actionTemplateStubs, actionTemplateModes), actionTemplateModes, onlyFaxReceivable);
	}

  function onActionTemplateListReceived(actionTemplateStubs: IActionTemplateStub[], modes: actionTemplateModes[]) {
    if (getIncludeBlank()) {
      templateSelect.append(new Option());
    }
    actionTemplateStubs.forEach((actionTemplateStub) => {
      var name = actionTemplateStub.Name;
      if (modes.length > 1) {
        name += " (" + actionTemplateModes[actionTemplateStub.Mode] + ")";
      }
			templateSelect.append(new Option(name, actionTemplateStub.Id.toString()));
		});
		templateSelect.attr("readonly", false as any);
  }

  function getSelectedDepartment(): string {
    return departmentSelect.val() as string;
  }

  function getSelectedModes(): actionTemplateModes[] {
    const actionTemplateMode = departmentSelect.data("mode");
    const actionTemplateModeStr = actionTemplateMode == undefined ? undefined : actionTemplateMode.toString();
    if (actionTemplateModeStr === undefined) {
      return (<any>Object).values(actionTemplateModes);
    }
    const actionTemplateModesStr = actionTemplateModeStr.split(",");
    return actionTemplateModesStr.map((value) => <actionTemplateModes>Number(value) );
  }

  function getOnlyFaxReceivable(): boolean {
    return departmentSelect.data("onlyfaxreceivable");
  }

  function getIncludeBlank(): boolean {
    return templateSelect.data("include-blank") === true;
  }
}